/**
 * Created by matei on 14/11/2019
 */

import Register from './register';

export default Register;
